import React from 'react'
import { useParams } from 'react-router-dom';
import artefactCategories from '../../../data/artefacts';

const Artrfact = () => {
    const { id } = useParams();

    const artefact = artefactCategories
        .flatMap(category => category.items)
        .find(item => item.link === id);

    if (!artefact) return <p>Артефакт не найден</p>;

    return (
        <div className='res__content' style={{margin: "0px 15px"}}>
            <div style={{fontSize: "12px", display: 'flex'}}>
                <svg style={{marginRight: "5px"}} width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.5 0C6.88 0 6.24834 0.119256 5.755 0.365292L0.46833 2.99747C0.15083 3.17095 0 3.45119 0 3.7531V9.95655C0 10.9582 0.690005 12.0633 1.58834 12.5103L5.96334 14.6738C6.83834 15.1083 8.16166 15.1092 9.03666 14.6738L13.4117 12.5103C14.3175 12.06 15 10.9666 15 9.95655V3.7531C15 3.45119 14.8475 3.14593 14.5317 2.99747L9.24499 0.365292C8.75166 0.119256 8.12 0 7.5 0ZM6.51 1.85069C7.03 1.59214 7.97 1.59214 8.49 1.85069L12.2917 3.7531L8.49 5.62965C7.97 5.8882 7.03 5.8882 6.51 5.62965C6.45166 5.60046 3.26167 4.02833 2.70833 3.7531L6.51 1.85069ZM1.66667 5.10839C2.435 5.49121 3.0775 5.79144 3.90667 6.20345C4.59584 6.5454 5.51917 7.0058 5.755 7.11505C6.11667 7.28269 6.35583 7.36693 6.66667 7.42781V13.1617L2.3175 10.9991C1.98584 10.8339 1.66667 10.3227 1.66667 9.95655V5.10839ZM13.3333 5.10839V9.95655C13.3333 10.331 12.9958 10.8556 12.6567 11.0249L8.33333 13.1617V7.42781C8.64417 7.36693 8.96166 7.26935 9.21833 7.14091L13.3333 5.10839Z" fill="black"/>
                </svg>
                <p>Артефакт: {artefact?.name}</p>
            </div>
                <div className='res__img-wrapper'>
                    <img className='res__img' src={artefact?.image} alt="res" />
                    <div className="res__img-overlay" />
                </div>
            <p className='res__text'>{artefact?.text}</p>
        </div>
    )
}

export default Artrfact
